import type { WaterIntelCapability } from './waterIntelTypes';

export const WATER_INTEL_CAPABILITIES = {
  BASIC_CURRENT: 'basic_current',
  DETAILED_CURRENT: 'detailed_current',
  CURRENT_FORECAST: 'current_forecast',
  CURRENT_HISTORY: 'current_history',
  BASIC_DEPTH: 'basic_depth',
  CONTOUR_LAYER: 'contour_layer',
  STRUCTURE_ANALYSIS: 'structure_analysis',
  ADVANCED_WATER_READ: 'advanced_water_read',
  SAVED_WATER_AREA: 'saved_water_area',
  OFFLINE_WATER_PACK: 'offline_water_pack',
} as const satisfies Record<string, WaterIntelCapability>;

// Phase A intentionally grants only the current read that is implemented.
// Later ad/Shell/Pro logic should resolve to this same capability vocabulary.
export const PHASE_A_DEFAULT_WATER_INTEL_CAPABILITIES: WaterIntelCapability[] = [
  WATER_INTEL_CAPABILITIES.BASIC_CURRENT,
];

export function normalizeRequestedWaterIntelCapabilities(
  input?: WaterIntelCapability[] | null,
): WaterIntelCapability[] {
  const allowed = new Set<WaterIntelCapability>(Object.values(WATER_INTEL_CAPABILITIES));
  const requested = Array.isArray(input) ? input : [];
  return Array.from(new Set(requested.filter((item): item is WaterIntelCapability => allowed.has(item))));
}
